import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Mine } from '~lmo/models/mine.model';
import { LmoFracsService } from '~lmo/services';
import { RouterStateService } from '~services/router-state.service';
import * as fromRouterConstants from '../../lmo-routing.constants';

@Component({
  selector: 'sa-lmo-loader-closed-schedule',
  styleUrls: ['./lmo-loader-closed-schedule.component.scss'],
  templateUrl: './lmo-loader-closed-schedule.component.html',
})
export class LmoLoaderClosedScheduleComponent implements OnInit {
  public inUseLoaders$: Observable<Mine[]>;
  public selectedId$: Observable<number>;
  constructor(private fracService: LmoFracsService, private routerState: RouterStateService) {}

  public ngOnInit() {
    this.selectedId$ = this.routerState.listenForParamChange$(fromRouterConstants.LOADER_CLOSED_HOURS_ID).pipe(
      filter((id) => !!id),
      map((id) => +id),
    );
    this.inUseLoaders$ = this.fracService.currentFrac$.pipe(map((frac) => (frac ? frac.fracMines : [])));
  }
}
